/**
 * Check if a user has permission access to certain route.
 * @param {string[]} accessibleRoutes  A list of accessible routes of a user (from server).
 * @param {object} route  The permission check route object.
 * @returns {boolean} True if current use has permission to access the route. False otherwise.
 */
export function routePermissionChecking(accessibleRouteNames, route) {
  // Admin has all routes access.
  if (accessibleRouteNames.indexOf('all') >= 0) {
    return true
  }

  if (route.meta && route.meta.accessibleName) {
    return accessibleRouteNames.some((accessibleRouteName) => {
      if (accessibleRouteName === '') {
        return false
      }
      return route.meta.accessibleName === accessibleRouteName
    })
  }

  return true
}

/**
 * Get back a list of filtered routes that the user has permission to access.
 * @param {object[]} routes  A complete list of route objects.
 * @param {string[]} accessibleRouteNames  A list of accessible routes of a user (from server).
 * @returns {boolean}
 */
export function getFilteredRoutesByAccessibleRouteNames(routes, accessibleRouteNames) {
  const filteredRoutes = routes.filter((route) => {
    const hasPermission = routePermissionChecking(accessibleRouteNames, route)
    if (hasPermission) {
      if (route.children) {
        // eslint-disable-next-line no-param-reassign
        route.children = getFilteredRoutesByAccessibleRouteNames(route.children, accessibleRouteNames)
        if (route.children.length === 0) {
          return false
        }
      }
      return true
    }
    return false
  })
  return filteredRoutes
}
